import { animate, state, style, transition, trigger } from "@angular/animations";
import { DecimalPipe, NgStyle } from "@angular/common";
import { Component, inject, OnInit, Renderer2, signal } from "@angular/core";
import { AngularFireAnalytics } from "@angular/fire/compat/analytics";
import { MatBottomSheet } from "@angular/material/bottom-sheet";
import { Data, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { IonicModule } from "@ionic/angular";
import { TranslatePipe, TranslateService } from "@ngx-translate/core";
import { AnimationItem } from "lottie-web";
import { AnimationOptions, LottieComponent } from "ngx-lottie";
import { throwError } from "rxjs";
import { catchError, take } from "rxjs/operators";
import { CommonVariable } from "src/app/app.constants";
import { SurpriseGiftSlideUpComponent } from "src/app/components/surprise-gift-slide-up/surprise-gift-slide-up.component";
import { JackpotTriggersService } from "src/app/services/jackpot-triggers.service";
import { SyndicateDataService } from "src/app/services/syndicate-data.service";
import { InProgressAnimationComponent } from "../../components/in-progress-animation/in-progress-animation.component";
import { DisplayCurrencyPipe } from "../../pipe/display-currency.pipe";
import { CheckWinningsRepositoryService } from "./check-winnings-repository.service";
import { ConvertToCashComponent } from "./convert-to-cash/convert-to-cash.component";
import { GameDatasService } from "../games/services/game-data.service";
@Component({
  selector: "app-check-winnings",
  templateUrl: "./check-winnings.component.html",
  styleUrls: ["./check-winnings.component.scss"],
  animations: [
    trigger("openClose", [
      state("open", style({
        height: "15.5vh",
      })),
      state("closed", style({
        height: "8.5vh",
      })),
      transition("open => closed", [animate("100ms")]),
      transition("closed => open", [animate("100ms")]),
    ]),
    trigger("openCloseCredit", [
      state("open", style({
        height: "auto",
      })),
      state("closed", style({
        height: "auto",
      })),
      transition("open => closed", [animate("100ms")]),
      transition("closed => open", [animate("100ms")]),
    ]),
  ],
  standalone: true,
  imports: [
    IonicModule,
    LottieComponent,
    NgStyle,
    InProgressAnimationComponent,
    DecimalPipe,
    DisplayCurrencyPipe,
    TranslatePipe,
  ],
})
export class CheckWinningsComponent implements OnInit {
  private bottomSheet = inject(MatBottomSheet);
  private checkWinningService = inject(CheckWinningsRepositoryService);
  private router = inject(Router);
  private analytics = inject(AngularFireAnalytics);
  public renderer = inject(Renderer2);
  private authService = inject(AuthService);
  public translate = inject(TranslateService);
  private jackpotTriggerService = inject(JackpotTriggersService);
  private syndicateDataService = inject(SyndicateDataService);
  private gameDatasService = inject(GameDatasService);
  isSetIndexSignal = signal(false);

  isAnimationVisible = signal<boolean>(true);
  lottieOptions!: AnimationOptions;
  private animation!: AnimationItem;
  isCashWinningsExpanded = false;
  isCreditWinningsExpanded = false;
  isLuckyDipExpanded = false;
  isRewardPointsExpanded = false;
  isluckyNumbersExpanded = false;
  isExpandedSubTitle = false;
  remoteConfigLuckyNumber = false;
  checkWinnings: any;
  lotto_lucky_dips: any;
  luckyNumbersData: any;
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  isGoldRingsExpanded = false;
  remoteConfigGoldRings = false;
  public preferredCurrency: string = CommonVariable.preferredCurrency;
  public currencySymbol: "£";
  public languageCode: string = "en";
  public prizeDrawContent: string;
  public luckyNumberCheckWinnings: any;
  public prizeDrawEntries: string;
  public replenished: string;
  public entriesDesc: string;
  public replenishedDesc: string;
  public title: string;
  public showPlayGame: boolean;
  public breakDownVisited: boolean;
  public sub_desc: string;
  public syndicateData: Data;
  public isWinMoreExpanded: boolean;
  public goldRingsCheckWinnings: Data;
  public goldRingsLinesBoosted: string;
  public goldRingsReplenished: string;
  public goldRingsBoosterDesc: string;
  public goldRingsReplenishedDesc: string;
  public goldRingsTitle: string;
  public goldRingsBoosterContent: string;
  private shortDiscription = signal("");
  public animationPath = "../../../assets/lotti_animation/surprise-gift-lotti.json";
  public userId: string;
  constructor() {
    this.authService.getConstantsMsg$.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    });
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        if (l) {
          this.selectedLanguage = l;
          this.translate.use(l ? l : "en");
        }
      },
      (err) => {
        /* const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
        this.authService.showToast(msg ? msg : "Something went wrong", "warning", ""); */
        this.authService.getConstantsMsg("1014").then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService?.showToastMessage(translatedMsg, defaultMsg);
        }).catch((error) => {
          return error;
        });

        this.routeToSyndicate();
        return err;
      }
    );

    this.authService?.userDetails$?.pipe(
      catchError((err) => {
        return err;
      })
    )?.subscribe(
      (user: Data) => {
        this.preferredCurrency = user?.preferred_currency ?? CommonVariable.preferredCurrency;
        // This variable is used to check if the user has visited the Break Down screen
        this.breakDownVisited = user?.is_breakdown_visited === true ? true : false;
        if (this.breakDownVisited) {
          this.showPlayGame = true;
        }
        this.authService.getCurrencyList$.subscribe((data: any) => {
          const CurrencyDetails = data?.details?.find((x: any) => x?.currency_code === this.preferredCurrency);
          this.currencySymbol = CurrencyDetails?.currency_symbol ?? CommonVariable.defaultCurrencySymbol;
        });
      },
      (err) => {
        return err;
      }
    );

    try {
      this.analytics.logEvent("check_winnings_screen", { userId: this.userId });
    } catch (e) { }
    this.getWinMoreDetails();
  }

  async ngOnInit() {
    await this.authService.getUid("CheckWinningsComponent").then((uid) => {
      this.userId = uid;
    })
    this.checkWinningService?.getCheckWinningSummary$?.subscribe(
      (data) => {
        this.checkWinnings = data;
        const { points_won, points_won_sum, credit_won, credit_won_sum } = this.checkWinnings || {};
        if (points_won && credit_won && credit_won_sum >= 0.50 && this.isAnimationVisible()) {
          this.getAnimationBasedOnCredit(credit_won_sum);
        } else if (points_won && points_won_sum > 100 && this.isAnimationVisible()) {
          this.getAnimationBasedOnPoints(points_won_sum);
        } else {
          this.isAnimationVisible.set(false);
        }
        try {
          this.authService.userDetails$.pipe(take(1)).subscribe(() => {
            if (this.checkWinnings?.gift_won_details && this.checkWinnings?.gift_won_details?.short_description) {
              const shortDescription = this.checkWinnings?.gift_won_details?.short_description;
              if (shortDescription) {
                this.currencyConversion(shortDescription);
              }
            }
          });
        } catch (error) {
          return error;
        }
      },
      (err) => {
        /* const msg = this.translatedToastMsg?.["1014"]?.[this.selectedLanguage];
        this.authService.showToast(msg ? msg : "Something went wrong", "warning", ""); */
        this.authService?.getConstantsMsg("1014")?.then((translatedMsg) => {
          const defaultMsg = {
            message: {
              line_1: "Something went wrong",
              line_2: "",
            },
            style: {
              icon: "tick circle error.svg",
              type: "Error",
            },
          };
          this.authService?.showToastMessage(translatedMsg, defaultMsg);
        }).catch((error) => {
          return error;
        });

        this.routeToSyndicate();
        return err;
      }
    );

    this.authService?.userDetails$?.pipe(
      catchError((err) => {
        return err;
      })
    )?.subscribe((user: Data) => {
      this.languageCode = user?.language_code ? user?.language_code : "en";
      this.jackpotTriggerService?.getTranslatedData(this.languageCode)?.subscribe((data) => {
        this.luckyNumberCheckWinnings = data?.["lucky_number_check_winnings"];
        this.prizeDrawEntries = this.luckyNumberCheckWinnings?.prize_draw_entries;
        this.replenished = this.luckyNumberCheckWinnings?.replenished;
        this.entriesDesc = this.luckyNumberCheckWinnings?.desc_1;
        this.replenishedDesc = this.luckyNumberCheckWinnings?.desc_2;
        this.title = this.luckyNumberCheckWinnings?.title;
        this.goldRingsCheckWinnings = data?.["gold_rings_check_winnings"];
        this.goldRingsLinesBoosted = this.goldRingsCheckWinnings?.lines_boosted;
        this.goldRingsReplenished = this.goldRingsCheckWinnings?.replenished;
        this.goldRingsBoosterDesc = this.goldRingsCheckWinnings?.desc_1;
        this.goldRingsReplenishedDesc = this.goldRingsCheckWinnings?.desc_2;
        this.goldRingsTitle = this.goldRingsCheckWinnings?.title;
        if (this.entriesDesc) {
          this.authService
            .getDVFromString(this.entriesDesc)
            .then((dvString: string) => {
              if (dvString) {
                this.prizeDrawContent = dvString;
              } else {
                return "";
              }
            })
            .catch((err) => {
              return err;
            });
        }
        if (this.goldRingsBoosterDesc) {
          this.authService
            .getDVFromString(this.goldRingsBoosterDesc)
            .then((dvString: string) => {
              if (dvString) {
                this.goldRingsBoosterContent = dvString;
              } else {
                return "";
              }
            })
            .catch((err) => {
              return err;
            });
        }
      });
    });
  }

  showDescription(type: string) {
    try {
      this.isExpandedSubTitle = !this.isExpandedSubTitle;
      if (type === "cash") {
        this.isCashWinningsExpanded = !this.isCashWinningsExpanded;
      } else if (type === "credit") {
        this.isCreditWinningsExpanded = !this.isCreditWinningsExpanded;
      } else if (type === "luckyDip") {
        this.isLuckyDipExpanded = !this.isLuckyDipExpanded;
      } else if (type === "rewards") {
        this.isRewardPointsExpanded = !this.isRewardPointsExpanded;
      } else if (type === "luckyNumbers") {
        this.isluckyNumbersExpanded = !this.isluckyNumbersExpanded;
      } else if (type === "win") {
        this.isWinMoreExpanded = !this.isWinMoreExpanded;
      } else if (type === "goldRings") {
        this.isGoldRingsExpanded = !this.isGoldRingsExpanded;
      }
    } catch (e) { }
  }

  openConvertToCash() {
    this.bottomSheet.open(ConvertToCashComponent, {
      panelClass: "convert-to-cash-dialog",
      data: this.checkWinnings,
    });
  }
  // This method has been used to open Break down components
  openBreakdown(claimEventId: string) {
    // check if visited break down page at least once
    if (!this.breakDownVisited) {
      this.authService.breakDownVisited(true);
    }
    // The event is fired when the user views the breakdown page for the upsell slide.
    if (!claimEventId) return new Error('claimEventId is missing');
    this.router.navigateByUrl(`checkWinnings/breakdown/${claimEventId}`);
  }

  routeToCashoutPage() {
    this.router.navigateByUrl("/cashout");
  }

  routeToSyndicate() {
    this.router.navigateByUrl("/mainTabs/tabs/syndicate");
  }
  routeToStorePage() {
    this.router.navigateByUrl("/mainTabs/tabs/store");
  }
  // This method has been used to redirect to the game page
  routeToGamePage() {
    this.router.navigateByUrl("/mainTabs/tabs/game");
  }
  // This method has been used to get win more details
  getWinMoreDetails() {
    this.syndicateDataService
      .getWinMoreDetails()
      .pipe(
        catchError((err) => {
          return throwError(err);
        })
      )
      .subscribe((response: Data) => {
        try {
          response.forEach((res: Data) => {
            if (res?.win_more_promise_details) {
              const endDate = res?.win_more_promise_details?.end_date.toDate().getTime(); //end date
              const currentDate = new Date().getTime(); //current date
              const TimeDifference = endDate - currentDate; // Get Time Difference
              const seconds = Math.floor((TimeDifference % (1000 * 60)) / 1000); //Get Seconds
              const days = Math.floor(TimeDifference / (1000 * 60 * 60 * 24)); // Get Days
              if (seconds >= 0) {
                res.win_more_end = false;
                res.left_days = days;
              } else {
                res.win_more_end = true;
                res.left_days = 0;
              }
            }
          });
          // filter data as per win more end status
          this.syndicateData = response.filter((x) => {
            const hundred = 100;
            const aloneCount = x?.win_more_promise_details?.alone_win_count;
            const togetherCount = x?.win_more_promise_details?.together_win_count;
            const totalWinnings = parseInt(aloneCount) + parseInt(togetherCount);
            const togetherProgress = Math.round(((togetherCount) / totalWinnings) * hundred);
            const aloneProgress = Math.round(((aloneCount) / totalWinnings) * hundred);
            x['togetherProgress'] = togetherProgress;
            x['aloneProgress'] = aloneProgress;
            return x?.win_more_end === false && togetherCount !== 0 && aloneCount !== 0;
          });
        } catch (err) {
          throw new Error(`Win more status not found ${err}`);
        }
      });
  }

  // This method has been used to open Surprise Gift Slide Up
  openSlideUp(checkWinningsGift: string) {
    this.checkWinningService.getCheckWinningsGift(checkWinningsGift).subscribe((res: Data) => {
      if (!res) return;
      this.bottomSheet.open(SurpriseGiftSlideUpComponent, {
        disableClose: true,
        data: res,
      });
    });
  }

  // This method is used to convert the currency according to user preference
  async currencyConversion(value) {
    // Check if the value contains the currency conversion directive
    if (value.indexOf("[currency_beautify:") === -1) return this.shortDiscription.set(value);
    // Get the start and end index of the currency substring
    const startIndex = value.indexOf("[currency_beautify:");
    const endIndex = value.indexOf("]", startIndex);
    // If the start and end index are found
    if (startIndex !== -1 && endIndex !== -1) {
      // Extract the currency substring
      const currencySubstring = value.substring(startIndex, endIndex + 1);
      // Fetch the currency value asynchronously
      const currencyValue = await this.gameDatasService.getDVCurrency(currencySubstring);
      // Replace the currency substring with the fetched currency value
      this.shortDiscription.set(value.replace(currencySubstring, currencyValue));
    }
  }
  /**
   * Sets the Lottie animation path.
   * @param path - The path to the Lottie animation file.
   */
  setLottiePath(path: string): void {
    try {
      this.lottieOptions = {
        path: path,
        loop: false, // Disable looping
      };
    } catch (error) {
      return error;
    }
  }

  /**
   * Gets the animation based on the given points.
   * @param points - The number of points to determine the animation.
   * @returns The name of the animation to be triggered.
   */
  getAnimationBasedOnPoints(points: number): string {
    try {
      this.setLottiePath("../../../assets/lotti_animation/points.json");
      if (points > 100 && points <= 350) {
        this.triggerAnimation("points-small-wave");
        return "points-small-wave"; // Points animation with a small wave
      } else if (points > 350) {
        this.triggerAnimation("points-full");
        return "points-full"; // Points animation with full wave
      }
      return ""; // Return empty string if points are not in valid range
    } catch (error) {
      return error; // Fallback return
    }
  }

  /**
   * Gets the animation based on the given credit.
   * @param credit - The amount of credit to determine the animation.
   * @returns The name of the animation to be triggered.
   */
  getAnimationBasedOnCredit(credit: number): string {
    try {
      this.setLottiePath("../../../assets/lotti_animation/points-and-credit.json");
      if (credit >= 0.5 && credit <= 2) {
        this.triggerAnimation("points-and-credit-small");
        return "points-and-credit-small"; // Small wave of balloons and credit
      } else if (credit > 2) {
        this.triggerAnimation("points-and-credit-full");
        return "points-and-credit-full"; // Full animation
      }
      return ""; // Return empty string if credit is not in valid range
    } catch (error) {
      return error; // Fallback return
    }
  }

  /**
   * Handles the animation creation event.
   * @param animationItem - The animation item created.
   */
  animationCreated(animationItem: AnimationItem): void {
    this.animation = animationItem;
    this.isSetIndexSignal.set(true);
    // Listen for the 'complete' event using a clean arrow function
    this.animation.addEventListener("complete", () => {
      this.isAnimationVisible.set(false);
    });
  }

  /**
   * Triggers the specified animation and stops it after a duration.
   * @param animationDuration - The duration string to determine animation behavior.
   */
  triggerAnimation(animationDuration: string): void {
    if (animationDuration.includes("small")) {
      setTimeout(() => {
        if (this.animation) {
          // Ensure the animation is defined before stopping
          this.animation.stop();
          this.isAnimationVisible.set(false);
        }
      }, 5000);
    }
  }

  ngOnDestroy() {
    if (this.animation) {
      this.animation?.destroy();
    }
  }
}
